module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "data-pdf-bookmark": "Part I. Meet the Team . . .",
      "data-type": "part",
      "epub:type": "part",
      "id": "d1e884"
    }
  }, [_c('h1', {
    staticClass: "PartTitlept"
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Team . . .")])]), _c('h1', {
    staticClass: "PartTitlept"
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE DIAMONDS ARE OUR WORLD’S BEST FRIENDS.")])]), _c('figure', {
    staticClass: "Illustrationholderill customimage"
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "Diamond.png",
      "src": "Diamond.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1h1"
  }, [_vm._v("Meet the Diamonds . . .")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("MICHELLE is always blowing bubbles, but best not stand too close when they start bursting. She’s")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("THE AMAZING BUBBLES!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Michelle LaFleur")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("New York, New York")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("HOWARD is the man that Jetboy would have been. He’s seen "), _c('em', [_vm._v("The Jolson Story,")]), _vm._v(" but his own tale is just beginning. Make way for")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("JETMAN!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Howard Hawkwood")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Philadelphia, Pennsylvania")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("IVAN is full of surprises. Like Mother Russia, the more you pound on him, the more you have to deal with. He’s")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("MATRYOSHKA!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Ivan Kazakova")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Brighton Beach, New York")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("MEGAN was dirt-poor growing up, but now she’s learned to shine. A regular diamond in the rough is our")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("TIFFANI!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Megan McKnee")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Boone, West Virginia")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("JOE be nimble, Joe be quick, Joe can snatch your candlestick. You better bring your best game if you want to go one-on-one with")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("JOE TWITCH!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Joe Moritz")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Baltimore, Maryland")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("EMILY is the fastest grrl on wheels. Don’t blink, or you’ll miss her whizzing by. There, that’s her, that")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("BLRR!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Emily Paige")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Sunnyvale, California")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Don’t you dare call RAJ handicapped. His servants wouldn’t take kindly to it. Step aside and clear a path for")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("THE MAHARAJAH!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Raj Chaturvedi")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Seattle, Washington")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa3f786e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part01.vue
// module id = 72
// module chunks = 0